import { graphql } from '@eluve/graphql.tada';

export const insertUserUploadMutation = graphql(`
  mutation insertUserUpload {
    insertUserUploadsOne(object: { status: PENDING_UPLOAD }) {
      __typename
      id
      status
    }
  }
`);

export const updateUserUploadMutation = graphql(`
  mutation updateUserUpload(
    $tenantId: uuid!
    $gcsFilePath: String
    $id: uuid!
    $status: UserUploadStatusEnum!
  ) {
    updateUserUploadsByPk(
      pkColumns: { tenantId: $tenantId, id: $id }
      _set: { fileUrl: $gcsFilePath, status: $status, uploadedAt: NOW }
    ) {
      __typename
      id
      status
    }
  }
`);
